import { TOOLS_CRUD_ACTION_CREATORS } from '../actions/tools_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

export const toolsRestCrudThunksForSupplier = new RestCrudThunks(
	'tools',
	'tool',
	'tool',
	'tools',
	TOOLS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

export const pickUpToolForSupplier = (toolId, data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${ROLE_TYPES.SUPPLIER}/inventory/tools/${toolId}/pickUp`;

	return (dispatch) => {
		const entity = { id: toolId };
		return new Promise((resolve, reject) => {
			dispatch(TOOLS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data,
					})
				)
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const dropOffToolForSupplier = (toolId, data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${ROLE_TYPES.SUPPLIER}/inventory/tools/${toolId}/dropOff`;

	return (dispatch) => {
		const entity = { id: toolId };
		return new Promise((resolve, reject) => {
			dispatch(TOOLS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data,
					})
				)
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const attachWorkOrdersToToolForSupplier = (toolId, workOrderIds) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${ROLE_TYPES.SUPPLIER}/inventory/tools/${toolId}/attachWorkOrders`;

	return (dispatch) => {
		const entity = { id: toolId };
		return new Promise((resolve, reject) => {
			dispatch(TOOLS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { workOrderIds },
					})
				)
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const detachWorkOrdersFromToolForSupplier = (toolId, workOrderIds) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${ROLE_TYPES.SUPPLIER}/inventory/tools/${toolId}/detachWorkOrders`;

	return (dispatch) => {
		const entity = { id: toolId };
		return new Promise((resolve, reject) => {
			dispatch(TOOLS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.post(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { workOrderIds },
					})
				)
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(TOOLS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TOOLS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
